import React, { useState } from 'react';
interface ProductImage {
  id: number;
  src: string;
  alt: string;
}
interface ProductGalleryProps {
  images: ProductImage[];
}
export const ProductGallery: React.FC<ProductGalleryProps> = ({
  images
}) => {
  const [activeImage, setActiveImage] = useState(0);
  return <div className="w-full lg:w-1/2" data-id="element-224">
      <div className="mb-4 overflow-hidden rounded-lg bg-gray-100" data-id="element-225">
        <img src={images[activeImage].src} alt={images[activeImage].alt} className="w-full h-auto object-cover transition-all duration-300 hover:scale-105" data-id="element-226" />
      </div>
      <div className="grid grid-cols-4 gap-2" data-id="element-227">
        {images.map((image, index) => <button key={image.id} onClick={() => setActiveImage(index)} className={`overflow-hidden rounded-md ${activeImage === index ? 'ring-2 ring-fuchsia-500' : 'ring-1 ring-gray-200 hover:ring-fuchsia-300'} transition-all duration-200`} aria-label={`View ${image.alt}`} data-id="element-228">
            <img src={image.src} alt={`Thumbnail for ${image.alt}`} className="w-full h-auto object-cover aspect-square" data-id="element-229" />
          </button>)}
      </div>
    </div>;
};